import type { AuthTenant, AuthUser } from "@/types";

import { readId, type UnknownRecord } from "@/utils/normalize";
import { resolveTenantName } from "@/utils/tenant";

export const normalizeUser = (input: UnknownRecord | undefined): AuthUser => ({
  id: readId(input?.id ?? input?._id),
  name: String(input?.name ?? input?.fullName ?? "Khách hàng ERP Gold"),
  email: typeof input?.email === "string" ? input.email : undefined,
  phone: typeof input?.phone === "string" ? input.phone : undefined,
  avatar: typeof input?.avatar === "string" ? input.avatar : undefined,
  role: typeof input?.role === "string" ? input.role : undefined,
  membership:
    typeof input?.membership === "string"
      ? (input.membership as "basic" | "silver" | "gold" | "platinum")
      : undefined,
  loyaltyPoints:
    typeof input?.loyalty_points === "number"
      ? input.loyalty_points
      : undefined,
  isGuest: typeof input?.is_guest === "boolean" ? input.is_guest : undefined,
  phoneVerified:
    typeof input?.phone_verified === "boolean"
      ? input.phone_verified
      : undefined,
});

export const normalizeTenant = (
  input: UnknownRecord | undefined,
): AuthTenant => {
  const tenantId = readId(input?.id ?? input?._id);

  return {
    id: tenantId,
    name:
      typeof input?.name === "string"
        ? input.name
        : resolveTenantName(tenantId),
    domain: typeof input?.domain === "string" ? input.domain : undefined,
    plan:
      input?.plan === "starter" ||
      input?.plan === "professional" ||
      input?.plan === "enterprise"
        ? input.plan
        : undefined,
    status:
      input?.status === "trial" ||
      input?.status === "active" ||
      input?.status === "grace" ||
      input?.status === "suspended"
        ? input.status
        : undefined,
    trialEndsAt:
      typeof input?.trialEndsAt === "string" ? input.trialEndsAt : undefined,
  };
};
